module.exports = __webpack_public_path__ + "img/pie-chart.ee2fe0cf.svg";